import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "actions-content" }
const _hoisted_3 = { class: "text-regular" }
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UilSpinner = _resolveComponent("UilSpinner")!
  const _component_UilClock = _resolveComponent("UilClock")!
  const _component_Counter = _resolveComponent("Counter")!
  const _component_TachePresenter = _resolveComponent("TachePresenter")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_ButtonPopover = _resolveComponent("ButtonPopover")!

  return (_ctx.taches.length > 0 || _ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_UilSpinner, {
              key: 0,
              class: "tache-spinner spin",
              size: "20"
            }))
          : (_openBlock(), _createBlock(_component_ButtonPopover, {
              key: 1,
              id: "button_taches",
              modelValue: _ctx.open,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.open) = $event)),
              color: "primary",
              icon: "left",
              placement: "bottom",
              trigger: "click"
            }, {
              "left-icon": _withCtx(() => [
                _createVNode(_component_UilClock, {
                  class: "context-menu-icon",
                  size: "16"
                }),
                (_ctx.types.en_cours.nbTaches)
                  ? (_openBlock(), _createBlock(_component_Counter, {
                      key: 0,
                      value: _ctx.spaceNumber(_ctx.types.en_cours.nbTaches),
                      size: "small"
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (item, type) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.title
                    }, [
                      _createElementVNode("strong", _hoisted_3, _toDisplayString(item.title), 1),
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tachesAffichees, (tache, index) => {
                          return (_openBlock(), _createBlock(_component_TachePresenter, {
                            key: `${tache.id}_${index}`,
                            tache: tache
                          }, null, 8, ["tache"]))
                        }), 128)),
                        (item.nbTaches === 0)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_4, _toDisplayString(_ctx.$t("tache.aucune-tache-en-cours")), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_Pagination, {
                        modelValue: _ctx.pageType[type],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.pageType[type]) = $event),
                        "total-rows": item.nbTaches,
                        "per-page": _ctx.subPageSize
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "total-rows", "per-page"])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]))
      ]))
    : _createCommentVNode("", true)
}